let dataLayer = (window.dataLayer = window.dataLayer || [])

const Tracker = {
  lead(data) {
    dataLayer.push({
      event: 'lead',
      data,
    })
  },
  download(type) {
    dataLayer.push({
      event: 'download',
      type,
    })
  },
}

export default Tracker
